import React from 'react';

import { ActionIcon, ActionIconProps } from '@mantine/core';

import classes from './kiloActionIcon.module.css';

type KiloActionIconProps = ActionIconProps & {
  children: React.ReactNode;
  rootVariantType?: 'default' | 'info' | 'danger' | 'defaultAbsolute'; // Add more as needed
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const KiloActionIcon = ({
  children,
  rootVariantType = 'default',
  ...rest
}: KiloActionIconProps): JSX.Element => {
  const variantClass = classes[rootVariantType];

  return (
    <ActionIcon {...rest} className={variantClass} data-disabled={rest.disabled || undefined}>
      {children}
    </ActionIcon>
  );
};

export default KiloActionIcon;
